/*!

 =========================================================
 * Vue Now UI Kit Pro - v1.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/vue-now-ui-kit-pro
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)

 * Designed by www.invisionapp.com Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
import App from "./App";
import router from "./router/";
import store from "./store/";
import VeeValidate from 'vee-validate';
import "./registerServiceWorker";
//plugins
import NowUIKit from './plugins/now-ui-kit';
import hljs from 'highlight.js';
import 'highlight.js/styles/github.css';

Vue.config.productionTip = false;
Vue.use(NowUIKit);

Vue.use(hljs.vuePlugin);

Vue.use(VeeValidate, {
	fieldsBagName: 'fieldsValidation',
	dictionary: {
		es: {
			messages: {
				after: (field, [target]) => `El campo debe ser posterior a ${target}.`,
				alpha_dash: (field) => `El campo solo debe contener letras, números y guiones.`,
				alpha_num: (field) => `El campo solo debe contener letras y números.`,
				alpha_spaces: (field) => `El campo solo debe contener letras y espacios.`,
				alpha: (field) => `El campo solo debe contener letras.`,
				before: (field, [target]) => `El campo debe ser anterior a ${target}.`,
				between: (field, [min, max]) => `El campo debe estar entre ${min} y ${max}.`,
				confirmed: (field) => `Los campos no coinciden.`,
				credit_card: (field) => `El campo es inválido.`,
				date_between: (field, [min, max]) => `El campo debe estar entre ${min} y ${max}.`,
				date_format: (field, [format]) => `El campo debe tener formato ${format}.`,
				decimal: (field, [decimals] = ['*']) => `El campo debe ser númerico y contener ${decimals === '*' ? '' : decimals} puntos decimales.`,
				digits: (field, [length]) => `El campo debe ser númerico y contener exactamente ${length} dígitos.`,
				dimensions: (field, [width, height]) => `El campo debe ser de ${width} pixeles por ${height} pixeles.`,
				email: (field) => `El campo debe ser un correo electrónico válido.`,
				ext: (field, format) => `El archivo debe ser de un formato válido. ${format}`,
				image: (field) => `El campo debe ser una imagen.`,
				in: (field) => `El campo debe ser un valor válido."`,
				ip: (field) => `El campo debe ser una dirección ip válida.`,
				max: (field, [length]) => `El campo no debe ser mayor a ${length} caracteres.`,
				max_value: (field, [max]) => `El campo debe de ser ${max} o menor.`,
				mimes: (field) => `El campo debe ser un tipo de archivo válido.`,
				min: (field, [length]) => `El campo debe tener al menos ${length} caracteres.`,
				min_value: (field, [min]) => `El campo debe ser ${min} o superior.`,
				not_in: (field) => `El campo debe ser un valor válido.`,
				numeric: (field) => `El campo debe contener solo caracteres númericos.`,
				regex: (field) => `El formato del campo no es válido.`,
				required: (field) => `El campo es obligatorio.`,
				size: (field, [size]) => `El campo debe ser menor a ${size} KB.`,
				url: (field) => `El campo no es una URL válida.`
			}
		}
	},
	locale: 'es',
	delay: 1000
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
